import React, { useState, useEffect } from "react";
import {
    Card,
    CardBody,
    CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
    Button,
    TextField,
    MuiThemeProvider,
    createMuiTheme,
    Dialog, DialogActions, DialogContent, DialogTitle,
    Typography
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import MultilanguageTabBlock from '../../../components/MultilanguageTabBlock';
import { deleteCategoryFaq, getCategoryFaqById, postCategoryFaq, updateCategoryFaq } from "../../../../api/categoryFaqs";
import TableFaq from "./TableFaq";
import UploadDocument from "../../../components/UploadDocument";

// Create theme for delete button (red)
const theme = createMuiTheme({
    palette: {
        secondary: {
            main: "#F64E60",
        },
    },
});

function getEmptyFaqs() {
    return {
        title: {
            'es': "",
            'en': ""
        },
        responseFaq: {
            'es': "",
            'en': ""
        },
        order: -1,
        file: null
    }
}

function getEmptyCategoryFaq() {
    return {
        title: {
            'es': "",
            'en': ""
        },
        faqs: [],
        order: -1,
        active: true
    };
}

function featureDialog(faqsOpen, setFaqsOpen, faqSelected, setFaqSelected, faqsData, setFaqsData, setTableKey, openFileDialog, setOpenFileDialog) {

    const dialogTitle = faqSelected.order < 0 ? "Create faq" : "Edit faq"


    const handleChange = (element, lang) => (event) => {
        if (lang) {
            if (event.target.value === ' ')
                return
            if (!faqSelected[element])
                faqSelected[element] = {}
            let newText = faqSelected[element]
            newText[lang] = event.target.value
            setFaqSelected({ ...faqSelected, [element]: newText })
        } else
            setFaqSelected({ ...faqSelected, [element]: event.target.value })
    }

    const renderMultilanguageTabContent = lang => {
        return (
            <>
                <TextField
                    label="Title"
                    value={(faqSelected.title && faqSelected.title[lang]) || ''}
                    onChange={handleChange('title', lang)}
                    margin="normal"
                    variant="outlined"
                    required
                />
                <TextField
                    label="Response"
                    value={(faqSelected.responseFaq && faqSelected.responseFaq[lang]) || ''}
                    onChange={handleChange('responseFaq', lang)}
                    margin="normal"
                    variant="outlined"
                    required
                />
            </>
        )
    }

    return (
        <Dialog
            open={faqsOpen}
            onClose={() => setFaqsOpen(false)}
            aria-labelledby="confirm-dialog"
            PaperProps={{
                style: {
                    width: '40vw',
                    height: '50vh',
                    maxWidth: 'none'
                }
            }}>
            <DialogTitle id="confirm-dialog">{dialogTitle}</DialogTitle>
            <DialogContent style={{ overflowX: 'hidden' }}>
                <MultilanguageTabBlock
                    multilanguageTabContent={renderMultilanguageTabContent}
                />
                <UploadDocument
                    objectClass={faqSelected}
                    setObjectClass={setFaqSelected}
                    openFileDialog={openFileDialog}
                    setOpenFileDialog={setOpenFileDialog}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {

                        if (!faqSelected.title?.es || faqSelected.title?.es.trim() === '') {
                            alertError({ customMessage: "Spanish title is required." });
                            return;
                        }

                        if (faqSelected.title?.en === '' || faqSelected.title?.en === '') {
                            alertError({ customMessage: "English title is required." });
                            return;
                        }


                        if (dialogTitle.includes("Create")) {
                            const lastOrder = faqsData.reduce((max, item) => Math.max(max, item.order || 0), 0);
                            const newBusiness = {
                                ...faqSelected,
                                order: faqsData.length === 0 ? lastOrder : lastOrder + 1,
                            };


                            setFaqsData([...faqsData, newBusiness]);

                        } else {
                            const updatedData = faqsData.map(item => item.order === faqSelected.order ? faqSelected : item);
                            setFaqsData(updatedData);
                        }
                        setTableKey(k => k + 1);
                        setFaqSelected(getEmptyFaqs())
                        setFaqsOpen(false)
                    }}
                >
                    Save
                </Button>
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => {
                        setFaqsOpen(false)
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default function EditCategoryFaqsPage() {
    const categoryFaqId = useParams().id;
    const history = useHistory();
    const {
        isLoading: isLoadingData,
        disableLoading: disableLoadingData,
        ContentSkeleton,
    } = useSkeleton();


    const [categoryFaq, setCategoryFaq] = useState(getEmptyCategoryFaq());
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    const [faqsData, setFaqsData] = useState([])
    const [faqsOpen, setFaqsOpen] = useState(false);
    const [faqSelected, setFaqSelected] = useState(getEmptyFaqs())
    const [tableKey, setTableKey] = useState(0);

    const [openFileDialog, setOpenFileDialog] = useState(false);

    useEffect(() => {
        if (!categoryFaqId) {
            disableLoadingData();
            return;
        }

        getCategoryFaqById(categoryFaqId)
            .then((res) => {
                setCategoryFaq(res.data);
                setFaqsData(res.data.faqs)
                disableLoadingData();
            })
            .catch((error) => {
                alertError({
                    error: error,
                    customMessage: "Could not get the category faq.",
                });
                history.push("/categoryFaqs");
            });
    }, [categoryFaqId, disableLoadingData, history]);

    function saveCategoryFaqs() {
        categoryFaq.faqs = faqsData.map(item => {
            let file = item.file;

            if (file instanceof File) {
                const ext = file.name.substring(file.name.lastIndexOf("."));
                const base = file.name.substring(0, file.name.lastIndexOf("."));
                const newName = `${base}-${Date.now()}${ext}`;

                file = new File([file], newName, { type: file.type });
            }

            return {
                title: item.title,
                responseFaq: item.responseFaq,
                order: item.order,
                fileURL: item.fileURL,
                file,
            };
        });


        if (!categoryFaqId) {
            postCategoryFaq(categoryFaq)
                .then((res) => {
                    alertSuccess({
                        title: "Saved!",
                        customMessage: "Category created successfully.",
                    });
                    history.push("/categoryFaqs");
                })
                .catch((error) => {
                    alertError({
                        error: error,
                        customMessage: "Could not save the category faqs.",
                    });
                });
        } else {
            updateCategoryFaq(categoryFaqId, categoryFaq)
                .then((res) => {
                    alertSuccess({
                        title: "Saved!",
                        customMessage: "Changes saved successfully.",
                    });
                    history.push("/categoryFaqs");
                })
                .catch((error) => {
                    alertError({
                        error: error,
                        customMessage: "Could not save the category faqs.",
                    });
                });
        }
    }

    const handleChangeLang = (element, lang) => (event) => {
        if (lang) {
            if (event.target.value === ' ')
                return
            if (!categoryFaq[element])
                categoryFaq[element] = {}
            let newText = categoryFaq[element]
            newText[lang] = event.target.value
            setCategoryFaq({ ...categoryFaq, [element]: newText })
        } else
            setCategoryFaq({ ...categoryFaq, [element]: event.target.value })
    }

    const renderMultilanguageTabContent = lang => {
        return (
            <>
                <TextField
                    label="Title"
                    value={(categoryFaq.title && categoryFaq.title[lang]) || ''}
                    onChange={handleChangeLang('title', lang)}
                    margin="normal"
                    variant="outlined"
                    required
                />
            </>
        )
    }

    if (isLoadingData)
        return <ContentSkeleton />;

    return (
        <>
            <Card>
                <CardHeader title="Edit category faq"></CardHeader>
                <CardBody>
                    <div className="d-flex align-item-center">
                        <div className="col-12">
                            <MultilanguageTabBlock multilanguageTabContent={renderMultilanguageTabContent} />
                        </div>
                    </div>


                    <div className="d-flex align-item-center mt-5">
                        <div className="col-3">
                            <Typography variant="h6" color="text.secondary">
                                Frequently Asked Questions
                            </Typography>
                        </div>
                        <div className="col-8" />
                        <div className="d-flex justify-content-end col-1">
                            <button
                                type="button"
                                className="btn btn-primary text-white"
                                onClick={() => {
                                    setFaqSelected(getEmptyFaqs());
                                    setFaqsOpen(true);
                                }}

                            >
                                Add new
                            </button>
                        </div>
                    </div>

                    <TableFaq
                        data={faqsData}
                        setData={setFaqsData}
                        setDataSelected={setFaqSelected}
                        setDataOpen={setFaqsOpen}
                        tableKey={tableKey}
                        setTableKey={setTableKey}
                    />
                </CardBody>
            </Card>


            <div style={{ display: "flex", flexDirection: "row" }}>
                <Button
                    onClick={() => history.push("/categoryFaqs")}
                    variant="outlined"
                    style={{ marginRight: "20px" }}
                >
                    Back
                </Button>

                <Button
                    onClick={() => saveCategoryFaqs()}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: "20px" }}
                >
                    Save category
                </Button>

                {featureDialog(faqsOpen, setFaqsOpen, faqSelected, setFaqSelected, faqsData, setFaqsData, setTableKey, openFileDialog, setOpenFileDialog)}

                {categoryFaqId && (
                    <>
                        <MuiThemeProvider theme={theme}>
                            <Button
                                onClick={() => setOpenConfirmDialog(true)}
                                variant="outlined"
                                color="secondary"
                                style={{ marginRight: "20px" }}
                            >
                                Delete category
                            </Button>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    marginLeft: "auto",
                                }}
                            ></div>
                        </MuiThemeProvider>

                        <ConfirmDialog
                            title={"Are you sure you want to delete this category faq?"}
                            open={openConfirmDialog}
                            setOpen={setOpenConfirmDialog}
                            onConfirm={() => {
                                deleteCategoryFaq(categoryFaqId)
                                    .then((res) => {
                                        alertSuccess({
                                            title: "Deleted!",
                                            customMessage: "Category plan deleted successfully.",
                                        });
                                        history.push("/categoryFaqs");
                                    })
                                    .catch((error) => {
                                        alertError({
                                            error: error,
                                            customMessage: "Could not delete the category plan.",
                                        });
                                    });
                            }}
                        />
                    </>
                )}
            </div>
        </>
    );
}
